import type { User, UserProfileBadge } from '../types';
import { isNutritionConsultant } from './userType';

const BADGE_ORDER: UserProfileBadge[] = ['ADMIN', 'CHEF', 'NUTRITIONIST'];

export function resolveUserProfileBadges(user: Pick<User, 'badges' | 'role' | 'chefId' | 'userType'>): UserProfileBadge[] {
    if (user.badges?.length) {
        return BADGE_ORDER.filter((badge) => user.badges!.includes(badge));
    }

    const derived: UserProfileBadge[] = [];
    if (user.role === 'admin' || user.role === 'superuser') {
        derived.push('ADMIN');
    }
    if (user.chefId) {
        derived.push('CHEF');
    }
    if (isNutritionConsultant(user)) {
        derived.push('NUTRITIONIST');
    }
    return derived;
}

export function getUserProfileBadgeTitle(badge: UserProfileBadge): string {
    switch (badge) {
        case 'ADMIN':
            return 'System Admin';
        case 'CHEF':
            return 'Verified Chef';
        case 'NUTRITIONIST':
            return 'Nutrition Consultant';
        default:
            return badge;
    }
}
